import React, { useState } from 'react';

// Speaker image map — add images here as speakers are confirmed
import spk1 from '../../assets/images/team/team-1-1.jpg';
import spk2 from '../../assets/images/team/team-1-2.jpg';
import spk3 from '../../assets/images/team/team-1-3.jpg';
import spk4 from '../../assets/images/team/team-1-4.jpg';
import spk5 from '../../assets/images/team/team-1-5.jpg';
import spk6 from '../../assets/images/team/team-1-6.jpg';

// eslint-disable-next-line no-unused-vars
const IMG_MAP = {
    'team-1-1.jpg': spk1, 'team-1-2.jpg': spk2, 'team-1-3.jpg': spk3,
    'team-1-4.jpg': spk4, 'team-1-5.jpg': spk5, 'team-1-6.jpg': spk6,
};
const TYPE_CONFIG = {
    keynote:  { label: 'Keynote',   color: '#FFD700', icon: 'fa-star' },
    talk:     { label: 'Talk',      color: '#00e5ff', icon: 'fa-microphone' },
    panel:    { label: 'Panel',     color: '#9c6fff', icon: 'fa-users' },
    workshop: { label: 'Workshop',  color: '#00e5ff', icon: 'fa-laptop-code' },
    demo:     { label: 'Demo',      color: '#69ff47', icon: 'fa-play-circle' },
    ctf:      { label: 'CTF',       color: '#69ff47', icon: 'fa-flag' },
    break:    { label: 'Break',     color: 'rgba(255,255,255,0.4)', icon: 'fa-coffee' },
    ceremony: { label: 'Ceremony',  color: 'var(--eventflow-base)', icon: 'fa-award' },
};

export default function ScheduleMain({ scheduleData }) {
    const { tracks, sessions, cfpCta } = scheduleData || { tracks: [], sessions: [], cfpCta: {} };
    const [activeTrack, setActiveTrack] = useState(tracks?.[0]?.id || '');

    const filtered = sessions.filter(s => s.track === activeTrack);
    const activeTrackData = tracks.find(t => t.id === activeTrack) || {};

    return (
        <section className="sch-main-v2">
            <style>{`
                .sch-main-v2 {
                    background-color: rgba(4, 0, 10, 0.70);
                    padding: 60px 0 100px;
                    position: relative;
                    overflow: hidden;
                }
                .sch-main-v2::before {
                    content: '';
                    position: absolute; inset: 0;
                    background: radial-gradient(ellipse at 70% 30%, rgba(var(--eventflow-primary-rgb),0.07) 0%, transparent 55%);
                    pointer-events: none;
                }

                /* ── Category Tabs ── */
                .sch-v2-tabs {
                    display: flex;
                    gap: 12px;
                    flex-wrap: wrap;
                    margin-bottom: 48px;
                    position: relative;
                    z-index: 1;
                }
                .sch-v2-tab {
                    display: inline-flex;
                    align-items: center;
                    gap: 10px;
                    font-family: var(--eventflow-font);
                    font-size: 14px;
                    font-weight: 700;
                    padding: 12px 28px;
                    border-radius: 50px;
                    border: 1px solid rgba(255,255,255,0.1);
                    background: transparent;
                    color: rgba(255,255,255,0.5);
                    cursor: pointer;
                    transition: all 0.3s ease;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }
                .sch-v2-tab i { font-size: 14px; }
                .sch-v2-tab:hover {
                    color: #fff;
                    border-color: rgba(255,255,255,0.25);
                    transform: translateY(-2px);
                }
                .sch-v2-tab--active {
                    color: #fff;
                    border-color: transparent;
                    box-shadow: 0 4px 20px rgba(0,0,0,0.3);
                }

                /* ── Track Header ── */
                .sch-v2-track-header {
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    margin-bottom: 40px;
                    padding-bottom: 24px;
                    border-bottom: 1px solid rgba(255,255,255,0.06);
                    position: relative;
                    z-index: 1;
                }
                .sch-v2-track-icon {
                    width: 52px;
                    height: 52px;
                    border-radius: 14px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 22px;
                    flex-shrink: 0;
                }
                .sch-v2-track-info h3 {
                    font-family: var(--eventflow-font);
                    font-size: 24px;
                    font-weight: 800;
                    color: #fff;
                    margin: 0 0 4px;
                }
                .sch-v2-track-info p {
                    font-family: var(--eventflow-font);
                    font-size: 14px;
                    color: rgba(255,255,255,0.4);
                    margin: 0;
                }

                /* ── Single Column List ── */
                .sch-v2-list {
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                    position: relative;
                    z-index: 1;
                }

                /* ── Horizontal Card ── */
                .sch-v2-card {
                    display: flex;
                    align-items: stretch;
                    background: rgba(255,255,255,0.03);
                    border: 1px solid rgba(255,255,255,0.08);
                    border-radius: 16px;
                    overflow: hidden;
                    transition: all 0.3s ease;
                }
                .sch-v2-card:hover {
                    transform: translateX(6px);
                    border-color: rgba(255,255,255,0.15);
                    box-shadow: 0 8px 32px rgba(0,0,0,0.3);
                }

                /* Speaker Image (left side) */
                .sch-v2-card__img {
                    width: 140px;
                    min-height: 140px;
                    flex-shrink: 0;
                    background: linear-gradient(135deg, rgba(var(--eventflow-primary-rgb),0.12) 0%, rgba(var(--eventflow-base-rgb),0.08) 100%);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    overflow: hidden;
                }
                .sch-v2-card__img img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
                .sch-v2-card__img-placeholder {
                    font-size: 32px;
                    color: rgba(255,255,255,0.15);
                }
                .sch-v2-card__img--white-placeholder {
                    background: #ffffff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .sch-v2-card__img--white-placeholder span {
                    font-family: var(--eventflow-font);
                    font-size: 14px;
                    font-weight: 700;
                    color: #333;
                    text-align: center;
                    padding: 10px;
                }

                /* Card Content (right side) */
                .sch-v2-card__content {
                    flex: 1;
                    padding: 20px 24px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    gap: 8px;
                }
                .sch-v2-card__top-row {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    flex-wrap: wrap;
                }
                .sch-v2-card__time {
                    font-family: 'Courier New', monospace;
                    font-size: 12px;
                    font-weight: 700;
                    color: rgba(255,255,255,0.4);
                    letter-spacing: 0.5px;
                    background: rgba(255,255,255,0.05);
                    padding: 4px 10px;
                    border-radius: 6px;
                }
                .sch-v2-card__type-badge {
                    display: inline-flex;
                    align-items: center;
                    gap: 5px;
                    padding: 4px 10px;
                    border-radius: 20px;
                    font-family: var(--eventflow-font);
                    font-size: 10px;
                    font-weight: 700;
                    letter-spacing: 1.5px;
                    text-transform: uppercase;
                }
                .sch-v2-card__type-badge i { font-size: 9px; }
                .sch-v2-card__title {
                    font-family: var(--eventflow-font);
                    font-size: 18px;
                    font-weight: 800;
                    color: #fff;
                    margin: 0;
                    line-height: 1.3;
                }
                .sch-v2-card__desc {
                    font-family: var(--eventflow-font);
                    font-size: 13px;
                    color: rgba(255,255,255,0.45);
                    line-height: 1.6;
                    margin: 0;
                }
                .sch-v2-card__speaker-name {
                    font-family: var(--eventflow-font);
                    font-size: 13px;
                    font-weight: 600;
                    color: rgba(255,255,255,0.7);
                }
                .sch-v2-card__speaker-name span {
                    color: rgba(255,255,255,0.35);
                    font-weight: 400;
                }

                /* Break card */
                .sch-v2-card--break {
                    background: rgba(255,255,255,0.02);
                    border-style: dashed;
                    border-color: rgba(255,255,255,0.06);
                }
                .sch-v2-card--break:hover {
                    transform: none;
                    box-shadow: none;
                }
                .sch-v2-card--break .sch-v2-card__img {
                    width: 70px;
                    min-height: 70px;
                }
                .sch-v2-card--break .sch-v2-card__title {
                    font-size: 15px;
                    color: rgba(255,255,255,0.5);
                }
                .sch-v2-card--break .sch-v2-card__content {
                    padding: 14px 20px;
                }

                /* ── CFP CTA ── */
                .sch-v2-cfp-cta {
                    margin-top: 56px;
                    background: rgba(var(--eventflow-base-rgb),0.05);
                    border: 1px dashed rgba(var(--eventflow-base-rgb),0.2);
                    border-radius: 16px;
                    padding: 36px 40px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 20px;
                    flex-wrap: wrap;
                    position: relative;
                    z-index: 1;
                }
                .sch-v2-cfp-cta h4 {
                    font-family: var(--eventflow-font);
                    font-size: 20px;
                    font-weight: 800;
                    color: #fff;
                    margin: 0 0 6px;
                }
                .sch-v2-cfp-cta p {
                    font-size: 14px;
                    color: rgba(255,255,255,0.4);
                    margin: 0;
                }

                /* ── Responsive ── */
                @media (max-width: 768px) {
                    .sch-v2-card {
                        flex-direction: column;
                    }
                    .sch-v2-card__img {
                        width: 100%;
                        min-height: 160px;
                        max-height: 200px;
                    }
                    .sch-v2-card__img--white-placeholder {
                        min-height: 160px;
                    }
                    .sch-v2-card--break {
                        flex-direction: row;
                    }
                    .sch-v2-card--break .sch-v2-card__img {
                        width: 60px;
                        min-height: 60px;
                        max-height: unset;
                    }
                    .sch-v2-tab {
                        font-size: 12px;
                        padding: 10px 18px;
                    }
                    .sch-v2-cfp-cta {
                        flex-direction: column;
                        padding: 24px 20px;
                        text-align: center;
                    }
                }
            `}</style>

            <div className="container">
                {/* Category Tabs */}
                <div className="sch-v2-tabs wow fadeInUp" data-wow-delay="100ms">
                    {tracks.map(t => (
                        <button
                            key={t.id}
                            className={`sch-v2-tab${activeTrack === t.id ? ' sch-v2-tab--active' : ''}`}
                            style={activeTrack === t.id
                                ? { background: t.color, borderColor: t.color, color: '#fff' }
                                : {}
                            }
                            onClick={() => setActiveTrack(t.id)}
                        >
                            <i className={`fa ${t.icon}`} style={activeTrack !== t.id ? { color: t.color } : {}} />
                            {t.label}
                        </button>
                    ))}
                </div>

                {/* Track Header */}
                <div className="sch-v2-track-header wow fadeInUp" data-wow-delay="120ms">
                    <div
                        className="sch-v2-track-icon"
                        style={{
                            background: `${activeTrackData.color}18`,
                            border: `1px solid ${activeTrackData.color}30`
                        }}
                    >
                        <i className={`fa ${activeTrackData.icon}`} style={{ color: activeTrackData.color }} />
                    </div>
                    <div className="sch-v2-track-info">
                        <h3>{activeTrackData.label}</h3>
                        <p>{activeTrackData.desc}</p>
                    </div>
                </div>

                {/* Single Column Cards */}
                <div className="sch-v2-list">
                    {filtered.map((session, idx) => {
                        const cfg = TYPE_CONFIG[session.type] || TYPE_CONFIG.talk;
                        const isBreak = session.type === 'break' || session.type === 'ceremony';
                        const hasSpeakers = session.speakers && session.speakers.length > 0;
                        const primarySpeaker = hasSpeakers ? session.speakers[0] : null;
                        const hasImage = primarySpeaker && primarySpeaker.img;

                        return (
                            <div
                                key={idx}
                                className={`sch-v2-card${isBreak ? ' sch-v2-card--break' : ''} wow fadeInUp`}
                                data-wow-delay={`${150 + idx * 40}ms`}
                            >
                                {/* Speaker Image */}
                                <div className="sch-v2-card__img">
                                    {hasImage ? (
                                        <img src={IMG_MAP[primarySpeaker.img] || primarySpeaker.img} alt={primarySpeaker.name} />
                                    ) : (
                                        <div className="sch-v2-card__img-placeholder">
                                            <i className={`fa ${cfg.icon}`} />
                                        </div>
                                    )}
                                </div>

                                {/* Content */}
                                <div className="sch-v2-card__content">
                                    <div className="sch-v2-card__top-row">
                                        <span className="sch-v2-card__time">{session.time}</span>
                                        <span
                                            className="sch-v2-card__type-badge"
                                            style={{
                                                color: cfg.color,
                                                background: `${cfg.color}15`,
                                                border: `1px solid ${cfg.color}30`,
                                            }}
                                        >
                                            <i className={`fa ${cfg.icon}`} />
                                            {cfg.label}
                                        </span>
                                    </div>
                                    <h4 className="sch-v2-card__title">{session.title}</h4>
                                    {!isBreak && <p className="sch-v2-card__desc">{session.desc}</p>}
                                    {hasSpeakers && (
                                        <div className="sch-v2-card__speaker-name">
                                            {session.speakers.map(sp => sp.name).join(', ')}
                                            {primarySpeaker.role && <span> · {primarySpeaker.role}</span>}
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>

                {/* CFP CTA */}
                <div className="sch-v2-cfp-cta wow fadeInUp" data-wow-delay="200ms">
                    <div>
                        <h4>{cfpCta.title}</h4>
                        <p>{cfpCta.description}</p>
                    </div>
                    <a href={cfpCta.buttonLink} className="thm-btn">
                        {cfpCta.buttonText} <span className="icon-arrow-right" />
                    </a>
                </div>
            </div>
        </section>
    );
}
